/* eslint-disable max-lines-per-function */
import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { NavTabs } from '@dreryk/react-components';

import { protectFeature } from '~libs.shared.system';
import { PatientGroupsAssignmentsPanel } from '~libs.desktop.patient-groups';

import { PatientPanelNavParams } from '../common/common.types';
import { ConsentsAndAuthorizationsPanel } from '../ConsentsAndAuthorizationsPanel/ConsentsAndAuthorizationsPanel';
import { MedicalDocumentRepositoryPanel } from '../MedicalDocumentRepositoryPanel/MedicalDocumentRepositoryPanel';
import { MedicalInformationPanel } from '../medicalInformation/MedicalInformationPanel';
import { UnsignedMedicalInformationAttachmentBadge } from '../medicalInformation/UnsignedMedicalInformationAttachmentBadge';
import {
   patientConsentsAndAuthorizationsTranslationKeys,
   patientMedicalDocumentRepositoryTranslationKeys,
   patientMedicalInformationTranslationKeys,
   patientTranslationKeys,
} from '../translations';

import { PatientConfirmedUpdatePersonalData } from './PatientConfirmedUpdatePersonalData/PatientConfirmedUpdatePersonalData';
import { PatientPrescriptionsHistory } from './PatientPrescriptionsHistory/PatientPrescriptionsHistory';
import { PatientVisitsHistory } from './PatientVisitsHistory/PatientVisitsHistory';

type PatientUpdatePanelNavTabsProps = {
   readonly patient: Patient;
};

export const PatientConfirmedUpdatePanelNavTabs = (props: PatientUpdatePanelNavTabsProps): JSX.Element => {
   return (
      <NavTabs<PatientPanelNavParams> testId={'patientUpdate'}>
         <NavTabs.Tab
            key={PatientPanelNavParams.PERSONAL_DATA}
            testId={PatientPanelNavParams.PERSONAL_DATA}
            param={PatientPanelNavParams.PERSONAL_DATA}
            label={patientTranslationKeys.personalData.tabName}
         >
            <PatientConfirmedUpdatePersonalData patient={props.patient} />
         </NavTabs.Tab>
         <NavTabs.Tab
            key={PatientPanelNavParams.PATIENT_GROUPS}
            testId={PatientPanelNavParams.PATIENT_GROUPS}
            param={PatientPanelNavParams.PATIENT_GROUPS}
            label={patientTranslationKeys.patientGroups.tabName}
         >
            <PatientGroupsAssignmentsPanel patientId={props.patient.id} />
         </NavTabs.Tab>
         {protectFeature(
            'searchingMedicalData',
            <NavTabs.Tab
               key={PatientPanelNavParams.MEDICAL_INFORMATION}
               testId={PatientPanelNavParams.MEDICAL_INFORMATION}
               param={PatientPanelNavParams.MEDICAL_INFORMATION}
               label={patientMedicalInformationTranslationKeys.tabName}
               activeSlot={<UnsignedMedicalInformationAttachmentBadge patientId={props.patient.id} />}
            >
               <MedicalInformationPanel patientId={props.patient.id} />
            </NavTabs.Tab>,
            null
         )}
         {protectFeature(
            'searchingMedicalData',
            <NavTabs.Tab
               key={PatientPanelNavParams.VISITS_HISTORY}
               testId={PatientPanelNavParams.VISITS_HISTORY}
               param={PatientPanelNavParams.VISITS_HISTORY}
               label={patientTranslationKeys.patientHistory}
            >
               <PatientVisitsHistory patientId={props.patient.id} />
            </NavTabs.Tab>,
            null
         )}
         {protectFeature(
            ['searchingMedicalData'],
            <NavTabs.Tab
               key={PatientPanelNavParams.PRESCRIPTIONS_HISTORY}
               testId={PatientPanelNavParams.PRESCRIPTIONS_HISTORY}
               param={PatientPanelNavParams.PRESCRIPTIONS_HISTORY}
               label={patientTranslationKeys.prescriptionsHistory}
            >
               <PatientPrescriptionsHistory patientId={props.patient.id} />
            </NavTabs.Tab>,
            null
         )}
         {protectFeature(
            'searchingMedicalData',
            <NavTabs.Tab
               key={PatientPanelNavParams.MEDICAL_DOCUMENT_REPOSITORY}
               testId={PatientPanelNavParams.MEDICAL_DOCUMENT_REPOSITORY}
               param={PatientPanelNavParams.MEDICAL_DOCUMENT_REPOSITORY}
               label={patientMedicalDocumentRepositoryTranslationKeys.tabName}
            >
               <MedicalDocumentRepositoryPanel patient={props.patient} />
            </NavTabs.Tab>,
            null
         )}
         <NavTabs.Tab
            key={PatientPanelNavParams.CONSENTS_AND_AUTHORIZATION}
            testId={PatientPanelNavParams.CONSENTS_AND_AUTHORIZATION}
            param={PatientPanelNavParams.CONSENTS_AND_AUTHORIZATION}
            label={patientConsentsAndAuthorizationsTranslationKeys.tabName}
         >
            <ConsentsAndAuthorizationsPanel patient={props.patient} />
         </NavTabs.Tab>
      </NavTabs>
   );
};
